<ui-card class="w-full min-w-52">
	<div card-header class="flex justify-between items-center">
		<h3 class="text-xl font-medium capitalize">Signers</h3>
		<ui-button
			ariaLabel="Edit Signers"
			preset="EXTRA_LOW_EMPHASIS"
			icon="edit"
			(click)="editSigners.emit()"
		/>
	</div>
	<ui-avatar-stack card-content [avatars]="avatars()" />
</ui-card>
